module.exports = __webpack_public_path__ + "static/media/antigua-accommodation-23.537ae60d.jpg";